import { Controller } from "react-hook-form";
import Creatable from "react-select/creatable";
import type { optionType, Translationtype } from "utils";
import { reactSelectColourStyles } from "./fromStyles";

interface IFormReactSelectProps {
  setValue?: any;
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  name: string;
  title: string;
  tooltip?: string;
  t: Translationtype;
  control: any;
  initialPlaceHolder?: string;
  disableClear?: boolean;
  options: optionType[];
}

export function FormCreatableSelect({
  errors,
  className,
  name,
  title,
  options,
  t,
  control,
  disableClear,
  disabled,
}: IFormReactSelectProps) {
  return (
    <div className={`${className || ""} w-full`}>
      <label htmlFor={name} className="w-full block mb-1 text-textColor">
        {title}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Creatable
            {...field}
            styles={reactSelectColourStyles}
            value={field.value}
            options={options}
            isClearable={!disableClear}
            isDisabled={disabled}
          />
        )}
      />

      {errors[name]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[name]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
